<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
        
        <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Modificar Alias CVU
            </b-card-header>
            <b-card-body>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-12">
                        <label>Alias</label>
                        <base-input v-model="model.AliasCVU"></base-input>
                    </div>
                </div>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-12">
                        <GoBackButton/>
                        <button @click="updateAliasCVU" class="btn btn-success">Aceptar</button>
                    </div>
                </div>
            </b-card-body>
        </b-card>  
    </div>
</template>

<script>

    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from "@/helpers/notificationHelpers";
    import GoBackButton from '@/components/Buttons/CASHGoBackButton'
    
    export default {
        name: 'UpdateAliasCVU',
        components: {
            GoBackButton
        },
        props: {
            AliasCVU: String
        },
        data(){
            return {
                model: 
                {
                    AliasCVU: this.AliasCVU
                }
            }
        },
        methods: {
            updateAliasCVU()
            {
                let context = this;
                axiosHelpers.axiosPost('Account/UpdateAccountAliasCVU', this.model, this, function(response) 
                    { 
                        var hasError = axiosHelpers.getResponseHasErrors(response);

                        if(!hasError)
                        {
                            notificationHelpers.showSuccess('Exito', 'Se actualizo correctamente el Alias CVU.', context); 
                            context.$router.push("micvu")
                        }
                    } );
            }
        }
        
    }
</script>